export default "__VITE_ASSET__b3aUOctC__"